import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import StarIcon from '@mui/icons-material/Star';
import ShareIcon from '@mui/icons-material/Share';

// 옵션 선택 모달 컴포넌트 완전히 삭제됨 (별도 파일로 분리)

export function ProductPreviewModern({
  images,
  currentImageIdx,
  setCurrentImageIdx,
  name,
  brand,
  description,
  price,
  reviewScore,
  reviewCount,
  detailImages = [], // 추가
  optionModalOpen,
  handleCloseModal,
}: {
  images: string[];
  currentImageIdx: number;
  setCurrentImageIdx: (idx: number) => void;
  name: string;
  brand: string;
  description: string;
  price: number;
  reviewScore?: number;
  reviewCount?: number;
  detailImages?: string[];
  optionModalOpen?: boolean;
  handleCloseModal?: () => void;
}) {
  // 옵션 예시 (실제 데이터 연동 필요)
  const [selected, setSelected] = useState({ color: '', size: '' });
  const options = { colors: ['블랙', '화이트', '베이지'], sizes: ['S', 'M', 'L', 'XL'] };
  const handleSelect = (type: 'color' | 'size', value: string) => {
    setSelected(prev => ({ ...prev, [type]: value }));
  };

  return (
    <Box sx={{ bgcolor: '#fafafa', borderRadius: 4, boxShadow: 2, p: 0, minHeight: 600, position: 'relative', overflow: 'hidden', paddingBottom: '80px', maxHeight: 800, overflowY: 'auto' }}>
      {/* 상단 바 */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 56, borderBottom: '1px solid #eee', position: 'relative', bgcolor: '#f7f7f7' }}>
        <IconButton sx={{ position: 'absolute', left: 8, top: 8 }}>
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography fontWeight={700} fontSize={24} letterSpacing={2}>CLOZET</Typography>
      </Box>
      {/* 이미지 슬라이더 */}
      <Box sx={{ width: '100%', height: 320, position: 'relative', bgcolor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={images[currentImageIdx]} alt="product" style={{ maxWidth: '100%', maxHeight: 320, objectFit: 'contain' }} />
        {/* 인디케이터 */}
        <Box sx={{ position: 'absolute', bottom: 12, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 1 }}>
          {images.map((_, idx) => (
            <Box key={idx} sx={{
              width: 8, height: 8, borderRadius: '50%',
              background: currentImageIdx === idx ? '#222' : '#ddd', mx: 0.5, cursor: 'pointer'
            }} onClick={() => setCurrentImageIdx(idx)} />
          ))}
        </Box>
        {/* 좌우 슬라이드 버튼(생략 가능) */}
        {currentImageIdx > 0 && (
          <IconButton sx={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)' }} onClick={() => setCurrentImageIdx(currentImageIdx - 1)}>
            <ArrowBackIosNewIcon />
          </IconButton>
        )}
        {currentImageIdx < images.length - 1 && (
          <IconButton sx={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%) rotate(180deg)' }} onClick={() => setCurrentImageIdx(currentImageIdx + 1)}>
            <ArrowBackIosNewIcon />
          </IconButton>
        )}
      </Box>
      {/* 하단 정보 */}
      <Box sx={{ p: 2, pt: 1, position: 'relative' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <IconButton><FavoriteBorderIcon /></IconButton>
          <Box flex={1} />
          <IconButton><ShareIcon /></IconButton>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography fontWeight={700} fontSize={16}>{brand}</Typography>
          <Typography color="text.secondary" sx={{ mx: 1 }}>{'>'}</Typography>
        </Box>
        <Typography fontSize={15} mb={0.5}>{name || '정보를 입력해주세요'}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <StarIcon sx={{ color: '#FFA726', fontSize: 18, mr: 0.5 }} />
          <Typography fontSize={14} fontWeight={500}>{reviewScore ?? 4.3}</Typography>
          <Typography fontSize={14} color="primary" sx={{ ml: 1, textDecoration: 'underline', cursor: 'pointer' }}>
            {reviewCount ? `${reviewCount}개의 리뷰 보기` : '18개의 리뷰 보기'}
          </Typography>
        </Box>
        <Typography fontWeight={700} fontSize={22} sx={{ position: 'absolute', right: 16, bottom: 16 }}>
          {price ? price.toLocaleString() + '원' : '정보를 입력해주세요'}
        </Typography>
        {/* 우측 하단 upward 버튼 */}
        <IconButton sx={{
          position: 'absolute', right: 16, bottom: 60, bgcolor: '#fff', borderRadius: 2, boxShadow: 2
        }}>
          <ArrowUpwardIcon />
        </IconButton>
      </Box>
      {/* 가격정보 하단 상세정보/바/상세이미지 */}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography fontWeight={700} fontSize={20} mb={0.5}>상세정보</Typography>
        <Box sx={{ width: '100%', height: 5, bgcolor: '#222', mx: 'auto', borderRadius: 2, mb: 3 }} />
        {/* 상세 이미지 리스트 */}
        <Box>
          {detailImages && detailImages.map((src, idx) => (
            <img key={idx} src={src} alt={`detail-${idx}`} style={{ width: '100%', maxWidth: '100%', margin: '0 auto 16px', display: 'block', borderRadius: 8 }} />
          ))}
        </Box>
      </Box>
      {/* 상세 보기 하단 삭제됨 */}
      {/* 구매하기 버튼은 부모에서만 렌더링 */}
      {/* 옵션 선택 모달 삭제됨 (부모에서만 렌더링) */}
    </Box>
  );
} 